














import Vue from "vue";
import Component from "vue-class-component";
import { PropSync } from "vue-property-decorator";

import { DateTime } from "luxon";

@Component({ components: {} })
export default class FastDateDetailWings extends Vue {
  @PropSync("from") dateFrom!: string;
  @PropSync("to") dateTo!: string;

  private options = ["min", "min_15", "hour", "today"];

  values(value: string, localTime: DateTime): string {
    switch (value) {
      case "min":
        return this.toISO(localTime.plus({ minute: -5 }));
      case "min_15":
        return this.toISO(localTime.plus({ minute: -15 }));
      case "hour":
        return this.toISO(localTime.plus({ hour: -1 }));
      case "today":
        return this.toISO(
            localTime.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        );
      default:
        return "";
    }
  }

  toISO(value: DateTime): string {
    return (
        value.set({ millisecond: 0, second: 0 }).toISO({
          includeOffset: false,
          suppressMilliseconds: true,
        }) ?? ""
    );
  }

  checkCurrent(value: string): boolean {
    return this.values(value, DateTime.local()) == this.dateFrom;
  }

  setDates(value: string): void {
    this.dateFrom = this.values(value, DateTime.local());
    this.dateTo = this.toISO(value === "today" ? DateTime.local().set({hour:23, minute:59, second: 0, millisecond: 0}):
        DateTime.local().plus({ minute: 1 }));
  }
}
